// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/illustration-template/src/index.tsx

import baseIllustration from '@bubble-ui/temp-illustration-base';
var IllustrationAddMoneyPath = 'M5 23h90.504v41.529h-7V30H12v40.996h57.927v7H5V23zm32.945 27.07c0-6.904 5.597-12.5 12.5-12.5 6.904 0 12.5 5.596 12.5 12.5 0 6.903-5.596 12.5-12.5 12.5-6.903 0-12.5-5.597-12.5-12.5zm18 0a5.5 5.5 0 10-11 0 5.5 5.5 0 0011 0zm-23.562 3.5H20.428v-7h11.955v7zm36.107 0h11.955v-7H68.49v7zm15.979 7.453l-10.576 17H84.47v12l11-19h-11v-10z';
var IllustrationAddMoney = baseIllustration('IllustrationAddMoney', {
  getPath: () => IllustrationAddMoneyPath
});

/**
 * @deprecated this component is outdated and will be removed with v6.0.0
 */
export default IllustrationAddMoney;
//# sourceMappingURL=index.js.map